import * as at from './text_input_action_types';
import {TEXT_MAX_LENGTH} from './text_input_constants';

export function setIsInvalidInput(stateId, isInvalid) {
  return {type: at.IS_INVALID_INPUT, payload: isInvalid, stateId};
}

export function changeText(stateId, text) {
  return (dispatch, getState) => {
    const textChange = text || '';
    let resultPromise;
    if (getState()[stateId] && getState()[stateId].text !== textChange) {
      const isInvalid = textChange.length > TEXT_MAX_LENGTH;
      if (getState()[stateId].isInvalidInput !== isInvalid) {
        // input state isInvalidInput changed, set it
        dispatch(setIsInvalidInput(stateId, isInvalid));
      }

      resultPromise = dispatch({type: at.CHANGE_TEXT, payload: text, stateId});
    } else {
      resultPromise = Promise.resolve();
    }
    return resultPromise;
  };
}

export function increaseSubmittingCounter(stateId) {
  return (dispatch) =>
    dispatch({type: at.INCREASE_SUBMITTING_COUNTER, stateId});
}

export function decreaseSubmittingCounter(stateId) {
  return (dispatch) =>
    dispatch({type: at.DECREASE_SUBMITTING_COUNTER, stateId});
}
